import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

type OrderItem = OAISchema['MarketOrderResponse'];
type CursorPagedResponse = OAISchema['CursorPagedResponse'];

// 페이지네이션 응답 타입 (content를 구체화)
export type OrderHistoryPageResponse = Omit<CursorPagedResponse, 'content'> & {
  content: OrderItem[];
};

type OrderDetailResponse = OAISchema['MarketOrderDetailsResponseV2'];

export interface OrderDataSource {
  getOrderHistories(params?: {
    lastOrderId?: number;
    size?: number;
  }): Promise<OrderHistoryPageResponse>;
  getOrderDetail(orderId: number): Promise<OrderDetailResponse>;
}

export class OrderDataSourceImpl implements OrderDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getOrderHistories(params?: { lastOrderId?: number; size?: number }) {
    return this.client.request<OrderHistoryPageResponse>({
      url: '/api/market-place/v1/orders',
      method: 'get',
      params,
    });
  }

  async getOrderDetail(orderId: number) {
    return this.client.request<OrderDetailResponse>({
      url: `/api/market-place/v2/orders/${orderId}/details`,
      method: 'get',
    });
  }
}

export const orderDataSource = new OrderDataSourceImpl();
